'use client'

import { Button } from '@algoacademy/design-system/web/actions/Button'
import { showErrorToast } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError'
import { ErrorMessage, Field, Label } from '@algoacademy/design-system/web/forms/Fieldset'
import { Input } from '@algoacademy/design-system/web/forms/Input'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { authClient } from '@/app/_auth/auth-client'
import type { ForgotPasswordSchema } from '../_schemas/forgotPassword'

export function ForgotPasswordForm() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<ForgotPasswordSchema>({ mode: 'onSubmit' })

  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (data: ForgotPasswordSchema) => {
    setIsLoading(true)

    const { error: resetError } = await authClient.requestPasswordReset({
      email: data.email,
      redirectTo: '/auth/new-password'
    })

    if (resetError) {
      showErrorToast(resetError.message ?? 'Wystąpił błąd. Spróbuj ponownie.')
      setIsLoading(false)
      return
    }

    toast.success(
      'Jeśli podany adres email istnieje w naszym systemie, wysłaliśmy link do resetu hasła.'
    )
    setIsLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='space-y-6'>
      <Field>
        <Label>Adres email</Label>
        <Input
          type='email'
          placeholder='email@example.com'
          {...register('email', { required: 'Wpisz adres email' })}
        />
        {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
      </Field>

      <Button type='submit' color='algoprimary' className='w-full' disabled={isLoading}>
        {isLoading ? 'Wysyłanie...' : 'Wyślij link'}
      </Button>
    </form>
  )
}
